/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
  $( function() {
  
    if ( $( '#industrySelect' ).length ) {
  
    $( '#industrySelect' ).click( function() {
      
      $( '#industrySelect .dropdown-items' ).toggleClass( 'showing' );
      
    });

      $("html, body").click(function(e) {
          if ( $(e.target).hasClass('toggle-ind-d') ) {
            $( '#industrySelect .dropdown-items' ).toggleClass( 'showing' );
          } else {
            $( '#industrySelect .dropdown-items' ).removeClass( 'showing' );
          }
      });

      $( '.industry-clicker' ).click( function() {

        $( '#industrySelect' ).css({
          width: 'auto',
          top: 0,
          border: 'none',
          background: 'none'
        }).children( '.current-text' ).text( $( this ).text() );
        window.location = 'https://www.melubabadges.com' + $( this ).data( 'slug' );

        $( '#industrySelectWrap' ).append( '<em>Loading Badges..</em>' )

      });

    }
    
  });